module.exports = "/images/kg.svg?96f98b525c3b5fed7a4fa8bda5a61cb8";